/**
 * TanStack Query hooks for `customer-io-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customerIoIntegrationQueryKeys,
	type CreateCustomerIoIntegrationBody,
	type ListCustomerIoIntegrationResponse,
	type CustomerIoIntegrationRow,
} from "./api";

export function useCustomerIoIntegrationList(): UseQueryResult<ListCustomerIoIntegrationResponse, Error> {
	return useQuery({
		queryKey: customerIoIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomerIoIntegrationCreate(): UseMutationResult<CustomerIoIntegrationRow, Error, CreateCustomerIoIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customerIoIntegrationQueryKeys.all });
		},
	});
}

export function useCustomerIoIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customerIoIntegrationQueryKeys.all });
		},
	});
}
